import { WizCommandManager } from './wiz-command.manager';
import { WizRoot } from '../../../components/views/wiz-root';
import { WIZ_COMMAND_HTTP_METHOD, WIZ_COMMAND_RESPONSE_TYPE, WIZ_COMMAND_STATE, WIZ_EVENT_TYPE, WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizEvent } from '../../../events/wiz-event';
import { WizEventManager } from '../../../events/wiz-event.manager';

/**
 * Single command (observable)
 */
export class WizCommand<T extends any> {

  /** UUID generated by constructor */
  public uuid: string;

  /** Command state */
  public state: string;

  /** Result callback */
  public callback: Function;

  /** Application lock request on call */
  public doLock: boolean = true;

  /** Service result */
  public result: T;

  /** Error stored */
  public error: Error;

  // REMOTE

  /** Http method (get / post) */
  public httpMethod: string = WIZ_COMMAND_HTTP_METHOD.POST;

  /** Return type */
  public responseType: string = WIZ_COMMAND_RESPONSE_TYPE.JSON;

  /** Service target URL */
  public url: string;

  /**
   * JSON call context
   * TODO splitter en CRIT /SCEN
   */
  public context: object;

  /**
   * Additional listeners that want to know the end result of this method
   */
  private _attachedListeners: Function[];

  private _isRemote: boolean;
  public get isRemote(): boolean {
    return this._isRemote;
  }

  private _toZip: boolean;
  public get toZip(): boolean {
    return this._toZip;
  }

  constructor() {
    this.uuid = WizMathUtils.createUUID();
    this.state = WIZ_COMMAND_STATE.INIT;
  }

  /**
   * Remote Remote configuration method
   * @param pUrl : Full target URL
   * @param pContext : JSON context (criteria / scenario)
   * @param pCallBack : Result return method
   * @param pMethod : http method
   * @param pResponseType : Response type
   * @param pLock : Lock usage
   */
  public configureRemote( pUrl: string,
                          pContext: object = null,
                          pCallback: Function = null,
                          pMethod: string = WIZ_COMMAND_HTTP_METHOD.POST,
                          pResponseType = WIZ_COMMAND_RESPONSE_TYPE.JSON,
                          pLock: boolean = true,
                          pToZip: boolean = false): WizCommand<T> {
      this._isRemote = true;
      this.url = pUrl;
      this.context = pContext;
      this.httpMethod = pMethod;
      this.responseType = pResponseType;
      this._toZip = pToZip;

      return this.configure(pCallback, pLock);
    }

  /**
   * Configuration method
   * @param pCallBack : Result return method
   * @param pLock : Lock usage
   */
  public configure( pCallback: Function = null,
                    pLock: boolean = true): WizCommand<T> {

    this.callback = pCallback;
    this.doLock = pLock;

    return this;
  }

  /**
   * Result on service call success
   */
  public wizCallResult(result: any)  {
    this.state = WIZ_COMMAND_STATE.SUCCESS;
    this.result = result;

    this.wizResult(); // generic method call

    if ( this.callback ) { // return to caller
      this.callback (this);
    }


    this.callListeners();
  }

  /** wizResult call for Observable fill */
  public wizResult()  {
  }

  /**
   * pour appel externe asynchrone
   */
  public resolve() {

  }

  /** Result on service call failure */
  public wizCallFault( error: Error )  {
    this.state = WIZ_COMMAND_STATE.FAULT;
    this.error = error;

    this.wizFault(); // generic method call
    if ( this.callback ) { // State return to master group command
      this.callback (this);
    }


    this.callListeners();
  }

  /** Generic wizFault call */
  public wizFault()  {
    if(!!WizRoot.root()) {
      WizEventManager.dispatchEvent(WizRoot.root(),  new WizEvent(WIZ_EVENT_TYPE.CMD_ERR, null, this));
    }
  }

  /** Execution call */
  public async execute(): Promise<any> {
    this.state = WIZ_COMMAND_STATE.PENDING;
    return WizCommandManager.executeCommand( this );
  }

  /**
   * Let's you attach an additional listener to the group command.
   *
   * Once the command ends, every attachedListeners will be called.
   *
   * @param pListener The method / function to call once the GroupCommand ends. The state will be provided
   */
  public attach(pListener: (pState: string) => void): void {
    if (!this._attachedListeners) {
      this._attachedListeners = [];
    }

    this._attachedListeners.push(pListener);
  }

  /**
   * Call the attached listeners to let them know that every thing is done
   */
  protected callListeners(): void {
    if (this._attachedListeners && this._attachedListeners.length) {
      this._attachedListeners.forEach(listener => listener(this.state));
    }
  }

  public wizExecute(): Promise<any> {
    return Promise.resolve();
  }
}
